<template>
    <div>
        <div class="pt-3 px-3">
            <div class="row pt-3 px-3">
                <input-date-time :disabled="disabled" label="Data inicial:" class="col-12 col-md-6" v-model="form.inicio" ref="form-dataInicio" required/>
                <input-date-time :disabled="disabled" label="Data final:" class="col-12 col-md-6" v-model="form.fim" ref="form-dataFim" required/>
            </div>
        </div>
        
        <template v-for="(tema,i) in form.selecaoTemaSubtemas">
            <div :class="`tema__background ${(i > 0 ? 'tema__no-border-top' : '')}  px-3`" :key="tema.temaSelecionado.temaId">
                <div class="row px-3 pt-2">
                    <div class="col-12">
                        <div class="row mb-2">
                            <input-select :disabled="disabled" :label="`Tema ${i+1}:`" :options="temas" v-model="tema.temaSelecionado.temaId" class="col-12" ref="form-tema" required >
                                <template #label>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div>
                                            {{`Tema ${i+1}:`}}
                                        </div>
                                        <b-button  variant="outline-danger" pill size="sm"  class="ml-2" @click="removeTema(tema)" v-if="form.selecaoTemaSubtemas.length > 1 && !disabled" >
                                            <i class="fa-solid fa-trash mr-2"></i>
                                            Remover tema
                                        </b-button>
                                    </div>
                                </template>
                                <template #append>
                                    <div >
                                        <div class="d-flex justify-content-center align-items-center" style="width:50px">
                                            <p class="h3 mt-2"><b-icon @click="openModal(i)" icon="exclamation-circle-fill"></b-icon></p>
                                        </div>
                                        <b-modal ref="modal" ok-only>
                                            <p>{{(tema.temaSelecionado.temaId && temas.length ? temas.find(el => el.value == tema.temaSelecionado.temaId).descricao : '')}}</p>
                                        </b-modal>
                                    </div>
                                </template>
                            </input-select>
                            <input-textarea class="col-12" v-model="tema.temaSelecionado.descricaoPersonalizada" v-if="(tema.temaSelecionado.temaId && temas.length ? temas.find(el => el.value == tema.temaSelecionado.temaId).text : '') == 'Outros'" ref="form-outro-tema" required no-label label="Outro tema" :max-length="200"/>
                            <input-select-tag :disabled="disabled" class="col-12" :options="subtemas"  v-model="tema.subtemas" label="Subtemas" id="subtema" @input="inserirSubtemas($event, tema)" />
                            <input-textarea class="col-12" v-model="getElementOutros(tema.subtemasSelecionados).descricaoPersonalizada" v-if="includesOutroSubtema(tema.subtemas)" ref="form-outro-subtema" required no-label label="Outro subtema" :max-length="200"/>

                            
                            <!--<VuePerfectScrollbar class="col-12 subtemas row" v-if="false">
                                <div class="col-12" v-for="subtema in subtemas.map(el => { return {value: el.id, text: el.nome} })" :key="subtema.value">
                                    <b-form-checkbox :disabled="disabled" v-model="tema.subtemas" :name="`tema_${i}`" :value="subtema.value">{{subtema.text}}</b-form-checkbox>
                                </div>                            
                            </VuePerfectScrollbar>-->
                        </div>                                            
                    </div>
                </div>
            </div>
        </template>
            
        <div class="px-3" >
            <div class="row p-3 ">
                <div class="col-12 d-flex justify-content-between">
                    <b-button v-if="!disabled" variant="outline-primary" @click="addTema" :disabled="form.selecaoTemaSubtemas.length == 5">
                        <b-icon icon="plus-circle-fill" class="mr-2"></b-icon>
                        Adicionar novo tema
                    </b-button>


                    
                    <b-button variant="success" v-if="!disabled" @click="$emit('save')">
                        <i class="fa-solid fa-check mr-2"></i>
                        Salvar planejamento
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import InfosService from "@/common/services/infos/infos.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import InputDateTime from "@/components/inputs/InputDateTime";
import InputSelect from "@/components/inputs/InputSelect";
import InputTextarea from "@/components/inputs/InputTextarea";
import InputSelectTag from "@/components/inputs/InputSelectTag";

//import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import {FormMixin} from "@/common/mixins/FormMixin";

export default {
    name: "PlanejamentoTema",
    mixins: [FormMixin],
    props :{
        disabled: {
            type: Boolean,
            default: false
        },
        form : {
            type : Object,
            default : () => ({
                dataInicio : null,
                dataFim : null,
                temasSelecionados : [],
            })
        }
    },
    components : {
        InputSelect,
        InputDateTime,
        //VuePerfectScrollbar,
        InputTextarea,
        InputSelectTag
    },
    data: () => ({
        temas : [],
        subtemas : [],
    }),
    methods :{
        openModal: function(i){
            this.$refs['modal'][i].show()
        },
        includesOutroSubtema: function(subtemas){
            let outro = this.subtemas.find(el => el.text == 'Outros');
            if(outro){
                return subtemas.includes(outro.value);
            }
            return false;
        },
        getElementOutros: function(subtemasSelecionados){
            let outroId = this.subtemas.find(el => el.text == 'Outros').value;
            return subtemasSelecionados.find(el => el.subtemaId == outroId);
        },
        fetchTemas: function(){
            this.$store.dispatch(START_LOADING);
            InfosService.buscarTemas().then(response => {
                this.temas = response.data.data.map(el => { return {value: el.id, text: el.nome, descricao: el.descricao} });
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },

        fetchSubtemas: function(){
            this.$store.dispatch(START_LOADING);
            InfosService.buscarSubtemas().then(response => {
                this.subtemas = response.data.data.map(el => { return {value: el.id, text: el.nome} });
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        addTema: function(){
            this.form.selecaoTemaSubtemas.push(
                {   
                    temaSelecionado : {
                        temaId: null,
                        descricaoPersonalizada: null,
                    },
                    subtemas :[],
                    subtemasSelecionados: []
                }
            );
        },
        removeTema: function(tema){
            this.form.selecaoTemaSubtemas.splice(this.form.selecaoTemaSubtemas.indexOf(tema), 1);
        },

        inserirSubtemas: function(e,tema){
            
            let outroId = this.subtemas.find(el => el.text == 'Outros').value;

            tema.subtemasSelecionados = e.map(el => {
                let element = {
                    subtemaId: el,
                    descricaoPersonalizada: (el == outroId ? tema.outroSubtema : null),
                }

                return element;
            });
        }
    },
    mounted(){
        this.fetchTemas();
        this.fetchSubtemas();
    },
}
</script>
<style>
    .tema__background {
        background: #e9e9e926;
        border-top: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
    }
    .tema__no-border-top {
        border-top: 0 !important;
    }

    .subtemas{
        max-height: 300px;
    }
</style>